import Tween from "tween.ts";
import Animation from "../../../../src/animation/Animation";


export default class AngularOscillationAnimation extends Animation {
  onUpdate: (a: number) => void;
  constructor(sAngle: number, onUpdate: (a: number) => void, onComp: () => void) {
    super();
    const d = 800;
    const angle = Math.PI / 12;

    this.onUpdate = onUpdate;

    this.moveRedPoint(sAngle, angle, d, () => {
      this.moveRedPoint(sAngle + angle, -angle * 2, d * 2, () => {
        this.moveRedPoint(sAngle - angle, angle, d, () => onComp())
      })
    })
  }

  moveRedPoint(sAngle, angle, duration, onComp: () => void) {
    const a = { angle: sAngle };
    new Tween.Tween({ ...a })
      .to({ angle: sAngle + angle }, duration)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((a) => {
        this.onUpdate(a.angle);
      })
      .onComplete(() => onComp())
      .start();
  }
}